import apiClient from './client';

/**
 * Submit a contact message/feedback.
 * 
 * @param {Object} data - The contact form data
 * @param {string} data.email - Email address for reply
 * @param {string} data.message - Message content (max 1000 chars)
 * @param {string} data.message_type - Type: 'bug_report', 'feature_request', 'adulation', 'other'
 * @param {string|null} data.clerk_user_id - Optional Clerk user ID
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const submitContactMessage = async (data) => {
  const response = await apiClient.post('/contact', data);
  return response.data;
};

